import { ApiError, apiClient } from 'shared/api';
import { Pageable } from 'shared/model';

import { MemberNotificationResponse, ReviewDetailResponse } from '../model/dto';

export const getMemberNotification = async (pageable?: Pageable): Promise<MemberNotificationResponse> => {
  const { data } = await apiClient.get('/member/notification', pageable);
  return data.result;
};

export const getReviewDetail = async (orderId: number): Promise<ReviewDetailResponse> => {
  const { data } = await apiClient.get(`/review/orders/${orderId}`);

  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data.result;
};

export const getReviewExists = async (orderId: number): Promise<{ memberReviewExists: boolean }> => {
  const { data } = await apiClient.get(`/review/orders/${orderId}/exists`);

  return data.result;
};
